module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#bundle",
      toString: function () {
        return this.url;
      }
    }